module.exports = __webpack_public_path__ + "img/icon-docx-document.54276061.svg";